import clsx from "clsx";
import { type FunctionComponent } from "react";
import type { PostListItem } from "~/database/post.model";
import TopHead from "../Top/TopHead";
import PostItem from "./PostItem";
import { Link } from "@remix-run/react";
import { buttonBase } from "../Common/FormStyle";
import { PR_COLORS } from "~/utils/const";
interface TopNewPostsProps {
  data: PostListItem[];
}

const TopNewPosts: FunctionComponent<
  TopNewPostsProps
> = ({ data }) => {
  return (
    <div
      className={clsx("pt-100", "max-md:pt-60")}
    >
      <TopHead>NEW POST</TopHead>
      <div
        className={clsx(
          "mx-auto mt-45 w-1305",
          "max-md:w-360",
          "max-md:mr-0",
        )}
      >
        <ul
          className={clsx(
            "grid grid-cols-3 gap-50",
            "max-md:flex",
            "max-md:flex-col",
            "max-md:gap-30",
          )}
        >
          {data?.map((el, i) => {
            return (
              <li key={i}>
                <PostItem
                  color={
                    PR_COLORS[
                      i % PR_COLORS.length
                    ]
                  }
                  data={el}
                ></PostItem>
              </li>
            );
          })}
        </ul>
      </div>
      <div
        className={clsx("text-center", "mt-40")}
      >
        <Link
          to="/new"
          className={clsx(
            buttonBase({
              size: "md",
            }),
          )}
        >
          See more
        </Link>
      </div>
    </div>
  );
};

export default TopNewPosts;
